var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ErrorPage"},[_c('div',{staticClass:"ErrorPage-Content"},[_c('h1',{staticClass:"title has-text-grey"},[_vm._v(" 422 ")]),_c('p',{staticClass:"subtitle has-text-grey-light"},[_vm._v(" "+_vm._s(_vm.validationMessage)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }